import { useState, useEffect, useCallback } from 'react';
import { api } from '../utils/api';
import { filterContracts, calculateStats } from '../utils/helpers';

export const useContracts = (selectedPeriod, selectedCategoria, selectedMandante, country) => {
  const [contracts, setContracts] = useState([]);
  const [stats, setStats] = useState(null);
  const [mandanti, setMandanti] = useState([]);
  const [categorie, setCategorie] = useState([]);
  const [lastUpdate, setLastUpdate] = useState(new Date());

  const loadContracts = useCallback(async () => {
    try {
      const data = await api.getContracts(country);
      
      const allMandanti = [...new Set(data.items.map(c => c.mandante))].filter(Boolean);
      setMandanti(allMandanti);
      
      const allCategorie = [...new Set(data.items.map(c => c.categoria))].filter(Boolean);
      setCategorie(allCategorie);
      
      const filtered = filterContracts(data.items, {
        period: selectedPeriod,
        categoria: selectedCategoria,
        mandante: selectedMandante
      });
      
      setContracts(filtered.sort((a, b) => b.timestamp - a.timestamp));
      setStats(calculateStats(filtered));
    } catch (error) {
      console.error('Error loading contracts:', error);
    }
  }, [selectedPeriod, selectedCategoria, selectedMandante, country]);

  const handleCategoriaChange = async (categoria) => {
    if (categoria !== 'all') {
      try {
        const data = await api.getContracts(country);
        const mandantiInCategoria = [...new Set(
          data.items
            .filter(c => c.categoria === categoria)
            .map(c => c.mandante)
        )];
        setMandanti(mandantiInCategoria);
      } catch (error) {
        console.error('Error loading mandanti:', error);
      }
    } else {
      const data = await api.getStats('today', country);
      setMandanti(Object.keys(data.byMandante));
    }
  };

  const refresh = () => {
    setLastUpdate(new Date());
    loadContracts();
  };

  useEffect(() => {
    loadContracts();
  }, [loadContracts]);

  return {
    contracts,
    stats,
    mandanti,
    categorie,
    lastUpdate,
    loadContracts,
    handleCategoriaChange,
    refresh
  };
};
